import $ from 'jquery';

global.$ = global.jQuery = window.$ = window.jQuery = $;

import 'jquery-validation';
import 'jquery-validation-unobtrusive';
//import 'babel-polyfill';

import Header from './layouts/header';
import Search from './layouts/search';
import Common from './components/common';

// load npm plugins
import 'angular';
import 'popper.js';
import 'bootstrap';
import 'slick-carousel';

// load external plugins
import './plugins/angular-init';
import './plugins/angular-bootstrap';

// load components
//import './components/FacetSearchResults/CustomResultsController';
//import './components/FacetSearchResults/LoadNextFacetSearchResultsCtrl';
//import './components/FacetSearchResults/PagesFilter';


$().ready(e => {
	let header = new Header();
	header.init();

	let search = new Search();
	search.init();

	let common = new Common();
	common.init();
});
